import script from "./Registration.vue?vue&type=script&setup=true&lang=js"
export * from "./Registration.vue?vue&type=script&setup=true&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=78ba5b8e&lang=scss"
import "./Registration.vue?vue&type=style&index=1&id=78ba5b8e&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ba5b8e"]])

export default __exports__